/** VAT rate options for raw product forms */
export const VAT_OPTIONS = [
  { value: '5.5', label: 'Taux à 5.50%' },
  { value: '10', label: 'Taux à 10%' },
  { value: '20', label: 'Taux à 20%' },
];
